// not ideal, it would be better to get the config values from toegang-toegang-infra
// but changing the working of config.js so it awaits a call to (static|assets)/app.config.json would be a huge refactor (getting the config would become async)

const determineEnv = () => {
    if (typeof window === 'undefined') return 'serverbuild';
    const origin = window.location?.origin ?? '';
    if (origin.startsWith('http://localhost:8094')) return 'local';
    if (origin.startsWith('https://beheer-ontwikkel.toegang.org') || origin.startsWith('https://test-beheer.toegang.org')) return 'test';
    if (origin.startsWith('https://beheer-test.toegang.org') || origin.startsWith('https://acc-beheer.toegang.org')) return 'acceptatie';
    if (origin.startsWith('https://beheer.toegang.org') || origin.startsWith('https://prod-beheer.toegang.org')) return 'productie';
    return 'unknown';
};

const config = {
    oauth_idp_base: 'http://localhost:8090/oidc',
    supportURL: 'http://support.toegang.org',
    supportPhoneNumber: '038-7114424',
    oauth_timeout: 3000,
    welcome_text: 'Welkom!',
    core_api: 'http://localhost:8091',
    log_api: 'http://localhost:9000',
    // this property is used
    // toeg_env: process.env.REACT_APP_TOEG_ENV || process.env.TOEG_ENV,
    toeg_env: determineEnv(),
    base: 'http://localhost:8090',
    // with create-react-app, process.env is read at build time
    // so process.env.REACT_APP_BRANCH and process.env.BRANCH will be undefined
    // this is not a problem because we don't use the buildstraat anymore
    branch: process.env.REACT_APP_BRANCH || process.env.BRANCH,
    primaryMain: '#00C2D1',
    primaryLight: '#EBFDFC',
    primaryDark: '#00909B',
    titleSuffix: '',
};

if (config.toeg_env === 'local') {
    config.debug = true;
    config.primaryMain = "#913fc0";
    config.primaryLight = "#f6e6ff";
    config.primaryDark = "#5d1a84";
    config.titleSuffix = 'Local';
} else if (config.toeg_env === 'test') {
    config.oauth_idp_base = 'https://idp-ontwikkel.toegang.org/oidc';
    config.core_api = 'https://api-ontwikkel.toegang.org';
    config.log_api = 'https://log-ontwikkel.toegang.org';
    config.base = 'https://idp-ontwikkel.toegang.org';
    config.primaryMain = "#a78124";
    config.primaryLight = "#fffae6";
    config.primaryDark = "#66490b";
    config.titleSuffix = 'Ontwikkel';
} else if (config.toeg_env === 'buildstraat') {
    config.oauth_idp_base = `https://${config.branch}-dot-idp-dot-toegang-ontwikkel.appspot.com/oidc`;
    config.core_api = `https://${config.branch}-dot-toegang-ontwikkel.appspot.com`;
    config.log_api = `https://${config.branch}-dot-logging-dot-toegang-ontwikkel.appspot.com`;
    config.base = `https://${config.branch}-dot-idp-dot-toegang-ontwikkel.appspot.com`;
}
if (config.toeg_env === 'acceptatie') {
    config.oauth_idp_base = 'https://idp-test.toegang.org/oidc';
    config.core_api = 'https://api-test.toegang.org';
    config.log_api = 'https://log-test.toegang.org';
    config.base = 'https://idp-test.toegang.org';
    config.primaryMain = '#01757e';
    config.primaryLight = '#c7e4e3';
    config.primaryDark = '#004e54';
    config.titleSuffix = 'Test';
} else if (config.toeg_env === 'productie') {
    // if prod- is in the url, automatically talk to prod- applications
    const origin = window?.location?.origin ?? '';
    const isProdInUrl = origin.startsWith('https://prod-');
    config.oauth_idp_base = `https://${isProdInUrl ? 'prod-' : ''}idp.toegang.org/oidc`;
    config.core_api = `https://${isProdInUrl ? 'prod-api' : 'api'}.toegang.org`;
    config.log_api = `https://${isProdInUrl ? 'prod-' : ''}log.toegang.org`;
    config.base = `https://${isProdInUrl ? 'prod-' : ''}idp.toegang.org`;
}




config.oauth_client = '9397a8e8-0afe-4c77-9fdc-c9f9be8c854a';
config.oauth_callback = 'http://localhost:8094/oauth';
config.base_uri = 'http://localhost:8094/';
config.push_public_key = 'BM0-zOyfqjgITKWq9WQEsH-SBm6iDgA1vTp865zztIyr1kPELmwZ23wRiaC6XDToIHmvgZJIzLkAxwhe5RJjAaE';
config.ph_beheer_url = 'http://localhost:3001';

if (config.toeg_env === 'test') {
    config.base_uri = 'https://beheer-ontwikkel.toegang.org/';
    config.oauth_callback = config.base_uri + 'oauth';
    config.push_public_key = 'BJDullrk5cN7_UsPC5Raz6jD1oX435e0sQux3HT8uRXL8C_WwPg1lsgKZSOna0AiX-6g0S5INPdKSPD4lEpnBR0';
    config.ph_beheer_url = 'https://profiel.ontwikkel.toegang.org';
}
if (config.toeg_env === 'acceptatie') {
    config.base_uri = 'https://beheer-test.toegang.org/';
    config.oauth_callback = config.base_uri + 'oauth';
    config.push_public_key = 'BE59O9s1iSI5dbmH9oW6qycujwWounbWzSKFmXZGqx4ukBT5w8NCPhAcQCm_o1tMZFMfW0DZhkMfy8RrwNatIKc';
    config.ph_beheer_url = 'https://acc.profiel.thiememeulenhoff.nl';
}
// if (config.toeg_env === 'buildstraat') {
//     config.base_uri = `https://${config.branch}-dot-beheer-dot-toegang-ontwikkel.appspot.com/`;
//     config.oauth_callback = config.base_uri + 'oauth';
//     config.push_public_key = 'BJDullrk5cN7_UsPC5Raz6jD1oX435e0sQux3HT8uRXL8C_WwPg1lsgKZSOna0AiX-6g0S5INPdKSPD4lEpnBR0';
// }
if (config.toeg_env === 'productie') {
    config.base_uri = 'https://beheer.toegang.org/';
    if (window.location?.origin?.startsWith('https://prod-beheer.toegang.org')) {
        config.base_uri = 'https://prod-beheer.toegang.org/';
    }
    config.oauth_callback = config.base_uri + 'oauth';
    config.push_public_key = 'BI4hdqJdmbs3cUigQ0qKDJI9cREvQVw3Lj58KQaOIHzvmap8VtgrIjdbK3gt7-flDBvISaKco6bQS2DH5J_x91o';
    config.ph_beheer_url = 'https://profiel.thiememeulenhoff.nl';
}

export default config;
